var $294f579ef11ab713$exports = {};
$294f579ef11ab713$exports = {
    "decrease": (args)=>`${args.fieldLabel} verlagen`,
    "increase": (args)=>`${args.fieldLabel} verhogen`,
    "numberField": `Getalveld`
};


export {$294f579ef11ab713$exports as default};
//# sourceMappingURL=nl-NL.mjs.map
